module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.b4917be2.woff";